import React from 'react';
import styled from 'styled-components';

import WatchNowIcon from 'components/icons/WatchNow';
import ActionButton from './ActionButton';

const StyledBtnText = styled.div`
  margin-left: 10px;
`;

const ComingSoonButton = () => (
  <ActionButton disabled>
    <WatchNowIcon color="#FFF" />
    <StyledBtnText>
      Coming Soon
    </StyledBtnText>
  </ActionButton>
);

export default ComingSoonButton;
